import { render, staticRenderFns } from "./DefaultSignupConfirmation.vue?vue&type=template&id=e547268a&lang=pug&"
import script from "./DefaultSignupConfirmation.vue?vue&type=script&lang=ts&"
export * from "./DefaultSignupConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports